export default __webpack_public_path__ + "static/productRiff-bcf4d2431174266b85a150d74415bd67.svg";